const NAImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007720117/KV-PCjpg.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007768584/KV-MOjpg.jpg',
};

const euImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007884977/EU-KV-PCjpg.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711007898107/EU-KV-MOjpg.jpg',
};

const ukImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710764492407/pc.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710764515105/h5.jpg',
};

const krImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711357407376/kr-KV-PCjpg.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711357446972/kr-KV-MOjpg.jpg',
};

const zaImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711595243435/za-KV.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711595345417/za-KV.jpg',
};

const auImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1712054500475/UK-KV-PC.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1712054568709/UK-KV-MO.jpg',
};

const jpImg = {
    pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1712730271464/jp-KV-PC.jpg',
    h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1712730271464/jp-KV-PC.jpg',
};

export const BannerImgAll: Record<string, { pc: string; h5: string }> = {
    us: NAImg,
    uk: ukImg,
    eu: euImg,
    de: euImg,
    fr: euImg,
    it: euImg,
    es: euImg,
    kr: krImg,
    za: zaImg,
    au: auImg,
    jp: jpImg,
};

export const tips: Record<string, { succcess_text: string; wrong_text: string }> = {
    us: {
        succcess_text: 'Thank you for subscribing!',
        wrong_text: 'Please enter a valid email address',
    },
    ca: {
        succcess_text: 'Thank you for subscribing!',
        wrong_text: 'Please enter a valid email address',
    },
    za: {
        succcess_text: 'Thank you for subscribing!',
        wrong_text: 'Please enter a valid email address',
    },
    au: {
        succcess_text: 'Thank you for subscribing!',
        wrong_text: 'Please enter a valid email address',
    },
    uk: {
        succcess_text: 'Thank you for subscribing!',
        wrong_text: 'Please enter a valid email address',
    },
    de: {
        succcess_text: 'Vielen Dank für Ihre Anmeldung!',
        wrong_text: 'Bitte geben Sie eine gültige E-Mail Adresse ein',
    },
    es: {
        succcess_text: '¡Gracias por suscribirte!',
        wrong_text: 'Introduce una dirección de correo electrónico válida',
    },
    fr: {
        succcess_text: 'Merci de votre inscription !',
        wrong_text: 'Veuillez saisir une adresse e-mail valide.',
    },
    it: {
        succcess_text: 'Grazie per avere effettuato l’iscrizione!',
        wrong_text: 'Inserisci un indirizzo e-mail valido',
    },
    jp: {
        succcess_text: 'ご登録ありがとうございます！',
        wrong_text: 'メールアドレスの形式が正しくありません',
    },
    kr: {
        succcess_text: '구독해주셔서 감사합니다!',
        wrong_text: '유효한 이메일 주소를 입력하세요',
    },
};
